// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__2AVgG","image":"style_image__1m0XV","des":"style_des__3opoh"};